import { Drawer, Image, Modal } from "antd";
import * as appRoutes from "config/routes.config";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

//!STYLES
import s from "./assets/menu.module.css";

//!IMAGES
import CouponIcon from "../../../../assets/images/app/coupon_icon.svg";
import Gamification from "../../../../assets/images/app/gamification.svg";
import Organisme from "../../../../assets/images/app/home/organisation.svg";
import Students from "../../../../assets/images/app/iam_student.svg";
import Teachers from "../../../../assets/images/app/iam_teacher.svg";
import Invitation from "../../../../assets/images/app/invitation.svg";
import Onboarding from "../../../../assets/images/app/onboarding_icon.svg";
import Teacher from "./assets/images/TeacherSvg.svg";
import Ads from "./assets/images/ads.svg";
import Aide from "./assets/images/aide.svg";
import Calendrier from "./assets/images/calendar.svg";
import Classes from "./assets/images/classes.svg";
import Contact from "./assets/images/contacte-nous.svg";
import Content from "./assets/images/contenu.svg";
import Message from "./assets/images/msg.svg";
import Porfeille from "./assets/images/portfeille.svg";
import FindTeacher from "./assets/images/prof.svg";
import Wallet from "./assets/images/wallet.svg";

//STUDENT
import Student from "./assets/images/student.svg";

import Close from "assets/images/app/close.svg";
import { UserRoles } from "common/enums";
import { toggleAppChat } from "store/AppChat/appChat";
import { setCheckClass, setIsCheckingBooking } from "store/app/appSlice";
import { setCouponDrawer } from "store/auth/authSlice";

const smallDevices = window.matchMedia("only screen and (max-width: 500px)");
const mediumDevices = window.matchMedia("only screen and (min-width: 500px)");

type Props = {
  visible: boolean;
  setVisible: any;
  openDrawer: any;
  openMessagerieDrawer?: any;
  openMessagerieDrawerStudent?: any;
  openPorteFeuilleDrawer__?: any;
  openPaiementDrawer?: any;
};

const MenuModal: FC<Props> = ({
  visible,
  setVisible,
  openDrawer,
  openMessagerieDrawerStudent,
  openPorteFeuilleDrawer__,
  openPaiementDrawer,
}) => {
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState<boolean>();
  const { user } = useSelector((state) => state.auth);
  const isStudent = user?.roles?.includes(UserRoles.STUDENT);
  const isTeacher = user?.roles?.includes(UserRoles.TEACHER);
  const isParent = user?.roles?.includes(UserRoles.PARENT);
  const isOrganism = user?.roles?.includes(UserRoles.ORGANISME);
  const isAdmin = user?.roles?.includes(UserRoles.ADMIN);

  const openMessagerieDrawer = () => dispatch(toggleAppChat(true));
  const openCouponsDrawer = () => dispatch(setCouponDrawer(true));

  const s_videoSizeController = (x: any) => {
    if (x.matches) {
      setIsMobile(true);
    }
  };

  const m_videoSizeController = (x: any) => {
    if (x.matches) {
      setIsMobile(false);
    }
  };

  // !USE_EFFECT
  useEffect(() => {
    s_videoSizeController(smallDevices);
    smallDevices.addListener(s_videoSizeController);
    m_videoSizeController(mediumDevices);
    mediumDevices.addListener(m_videoSizeController);
  }, []);

  const teacherData: {
    id: number;
    name: string;
    icon: any;
    link: string;
    openDrawer?: any;
    openMessagerieDrawer?: any;
    openPorteFeuilleDrawer__?: any;
    iconSize?: number;
  }[] = [
      {
        id: 1,
        name: "Mon profil",
        icon: Teacher,
        link: "#",
        openDrawer: openDrawer,
      },
      {
        id: 2,
        name: "Portefeuille",
        icon: Porfeille,
        link: "#",
        openDrawer: openPorteFeuilleDrawer__,
      },
      /* {
        id: 3,
        name: "messagerie",
        icon: Message,
        link: "#",
        openDrawer: openMessagerieDrawer,
      }, */
      {
        id: 7,
        name: "Mon contenu",
        icon: Content,
        link: appRoutes.COURSESBYLEVELS,
      },
      {
        id: 8,
        name: "Mes élèves",
        icon: Students,
        link: appRoutes.TEACHER_STUDENTS,
      },
      {
        id: 4,
        name: "Réservations",
        icon: Calendrier,
        link: "/teacher/calendrier",
      },
      {
        id: 9,
        name: "Mes classes",
        icon: Classes,
        link: "/teacher/rooms",
      },
      {
        id: 10,
        name: "Mes Coupons",
        icon: CouponIcon,
        link: "#",
        openDrawer: openCouponsDrawer,
        iconSize: 30,
      },
      {
        id: 12,
        name: "Guide de démarrage",
        icon: Onboarding,
        link: appRoutes.ONBOARDING,
        iconSize: 30,
      },
      {
        id: 3,
        name: "Gamification",
        icon: Gamification,
        link: appRoutes.TEACHER_GAMIFICATION,
      },
      {
        id: 5,
        name: "FAQ",
        icon: Aide,
        link: appRoutes.FAQ,
      },
      {
        id: 6,
        name: "Contacte-nous",
        icon: Contact,
        link: appRoutes.TEACHER_CONTACT,
      },
    ];

  const adminData: {
    id: number;
    name: string;
    icon: any;
    link: string;
    openDrawer?: any;
    openMessagerieDrawer?: any;
    openPorteFeuilleDrawer__?: any;
    iconSize?: number;
  }[] = [
      {
        id: 1,
        name: "Mon profil",
        icon: Teacher,
        link: "#",
        openDrawer: openDrawer,
      },
      {
        id: 2,
        name: "Portefeuille",
        icon: Porfeille,
        link: "#",
        openDrawer: openPorteFeuilleDrawer__,
      },
      {
        id: 7,
        name: "Mon contenu",
        icon: Content,
        link: appRoutes.COURSESBYLEVELS,
      },
      {
        id: 9,
        name: "Mes classes",
        icon: Classes,
        link: "/teacher/rooms",
      },
      {
        id: 5,
        name: "Aide",
        icon: Aide,
        link: appRoutes.FAQ,
      },
      {
        id: 6,
        name: "Gestion organisme",
        icon: Organisme,
        link: appRoutes.GESTION_ORGANISME,
      },
    ];

  const TeacherNotVerifiedData: {
    id: number;
    name: string;
    icon: any;
    link: string;
    openDrawer?: any;
    openMessagerieDrawer?: any;
    openPorteFeuilleDrawer__?: any;
    iconSize?: number;
  }[] = [
      {
        id: 1,
        name: "parametres",
        icon: Teacher,
        link: "#",
        openDrawer: openDrawer,
      },
      {
        id: 3,
        name: "messagerie",
        icon: Message,
        link: "#",
        openDrawer: openMessagerieDrawer,
      },
      {
        id: 4,
        name: "Réservations",
        icon: Calendrier,
        link: user?.step === "completed" ? "/teacher/calendar" : appRoutes.COMPLETE_PROFILE,
      },
      {
        id: 7,
        name: "Mon contenu",
        icon: Content,
        link: appRoutes.COURSESBYLEVELS,
      },
      {
        id: 8,
        name: "Accueil",
        icon: Ads,
        link: "/feeds",
      },
      {
        id: 12,
        name: "Guide de démarrage",
        icon: Onboarding,
        link: appRoutes.ONBOARDING,
        iconSize: 30,
      },
      {
        id: 2,
        name: "Gamification",
        icon: Gamification,
        link: appRoutes.TEACHER_GAMIFICATION,
      },
      {
        id: 5,
        name: "Aide",
        icon: Aide,
        link: appRoutes.FAQ,
      },
      {
        id: 6,
        name: isAdmin ? "Gestion organisme" : "Contacte-nous",
        icon: isAdmin ? Organisme : Contact,
        link: isAdmin ? appRoutes.GESTION_ORGANISME : appRoutes.TEACHER_CONTACT,
      },
    ];

  const MenuStudent: {
    id: number;
    name: string;
    icon: any;
    link: string;
    openDrawer?: any;
    openPaiementDrawer?: any;
  }[] = [
      {
        id: 0,
        name: "Mes classes",
        icon: Classes,
        link: appRoutes.STUDENT_MY_CLASS,
      },
      /* {
        id: 1,
        name: "Mon profil",
        icon: Student,
        link: "/",
        openDrawer: openDrawer,
      }, */
      {
        id: 1,
        name: "Moyen de paiement",
        icon: Porfeille,
        link: "#",
        openDrawer: openPaiementDrawer,
      },
      /* {
        id: 3,
        name: "messagerie",
        icon: Message,
        link: "#",
        openDrawer: () => dispatch(toggleAppChat(true)),
      }, */
      {
        id: 7,
        name: "calendrier",
        icon: Calendrier,
        link: appRoutes.STUDENT_CALENDAR,
      },
      /* {
        id: 5,
        name: "Accueil",
        icon: Ads,
        link: "/feeds",
      }, */
      {
        id: 8,
        name: "Je m'entraine",
        icon: Content,
        link: appRoutes.STUDENT_MY_CONTENT,
      },
      /* {
        id: 7,
        name: "Trouver un prof",
        icon: SearchProf,
        link: appRoutes.STUDENT_SEARCH_BEST_TEACHER,
      }, */
      /* {
        id: 8,
        name: "Mes classes",
        icon: Classes,
        link: appRoutes.STUDENT_MY_CLASS,
      }, */
      {
        id: 2,
        name: "Guide de démarrage",
        icon: Onboarding,
        link: appRoutes.ONBOARDING,
      },
      {
        id: 3,
        name: "Gamification",
        icon: Gamification,
        link: appRoutes.STUDENT_GAMIFICATION,
      },
      {
        id: 4,
        name: "FAQ",
        icon: Aide,
        link: appRoutes.FAQ,
      },
      {
        id: 5,
        name: "Contacte-nous",
        icon: Contact,
        link: appRoutes.TEACHER_CONTACT,
      },
      {
        id: 9,
        name: "Mes invitations",
        icon: Invitation,
        link: appRoutes.STUDENT_INVITATIONS,
      },
      /* {
        id: 6,
        name: "Blog",
        icon: Blog,
        link: "https://blog.monamialbert.com/",
      }, */
    ];

  const MENU_STUDENT_MOBILE = [
    "Je m'entraine",
    "parametres",
    "calendrier",
    "mes classes",
    "aide",
    "moyen de paiement",
  ];

  const MenuOrganism: {
    id: number;
    name: string;
    icon: any;
    link: string;
    openDrawer?: any;
    openPaiementDrawer?: any;
  }[] = [
      {
        id: 0,
        name: "Mes classes",
        icon: Classes,
        link: isParent ? appRoutes.PARENT_CLASSES : appRoutes.ORGANISM_CLASSES,
      },
      {
        id: 1,
        name: "Mes élèves",
        icon: Student,
        link: isParent ? appRoutes.PARENT_DASHBOARD : appRoutes.ORGANISM_DASHBOARD,
      },
      {
        id: 1,
        name: "Mes profs",
        icon: Teachers,
        link: appRoutes.ORGANISM_TEACHERS,
      },
      {
        id: 2,
        name: "Annuaire des profs",
        icon: FindTeacher,
        link: isParent ? appRoutes.FIND_STUDENT_TEACHER : appRoutes.ORGANISM_FIND_STUDENT_TEACHER,
      },
      /* {
        id: 3,
        name: "Messagerie",
        icon: Message,
        link: "#",
      }, */
      {
        id: 4,
        name: "Portefeuille",
        icon: Wallet,
        link: isParent ? appRoutes.WALLETS : appRoutes.ORGANISM_WALLETS,
      },
      {
        id: 7,
        name: "calendrier",
        icon: Calendrier,
        link: appRoutes.ORGANISM_CALENDAR,
      },
      {
        id: 5,
        name: "Contacte-nous",
        icon: Contact,
        link: appRoutes.TEACHER_CONTACT,
      },
      {
        id: 6,
        name: "Aide",
        icon: Aide,
        link: appRoutes.FAQ,
      },
    ];

  const MenuParent: {
    id: number;
    name: string;
    icon: any;
    link: string;
    openDrawer?: any;
    openPaiementDrawer?: any;
  }[] = [
      {
        id: 0,
        name: "Mes classes",
        icon: Classes,
        link: isParent ? appRoutes.PARENT_CLASSES : appRoutes.ORGANISM_CLASSES,
      },
      {
        id: 1,
        name: "Mes élèves",
        icon: Student,
        link: isParent ? appRoutes.PARENT_DASHBOARD : appRoutes.ORGANISM_DASHBOARD,
      },
      {
        id: 2,
        name: "Annuaire des profs",
        icon: FindTeacher,
        link: isParent ? appRoutes.FIND_STUDENT_TEACHER : appRoutes.ORGANISM_FIND_STUDENT_TEACHER,
      },
      {
        id: 3,
        name: "Messagerie",
        icon: Message,
        link: "#",
      },
      {
        id: 4,
        name: "Portefeuille",
        icon: Wallet,
        link: isParent ? appRoutes.WALLETS : appRoutes.ORGANISM_WALLETS,
      },
      {
        id: 5,
        name: "Contacte-nous",
        icon: Contact,
        link: appRoutes.TEACHER_CONTACT,
      },
      {
        id: 6,
        name: "Aide",
        icon: Aide,
        link: appRoutes.FAQ,
      },
    ];

  return (
    <>
      {isMobile ? (
        <Drawer
          closeIcon={<Image preview={false} src={Close} width={25} />}
          visible={visible}
          height={"100%"}
          onClose={() => setVisible(false)}
          placement="bottom"
        >
          <div className={s.container}>
            <div className={s.row}>
              {isTeacher && user?.isActive && user?.step === "completed" && isAdmin && adminData.map((item: any) => (
                <Link
                  to={item?.link}
                  key={item.id}
                  onClick={() => { item.id === 9 ? dispatch(setCheckClass(true)) : dispatch(setCheckClass(false)); setVisible(false) }}
                >
                  <div className={s.card} onClick={item?.openDrawer}>
                    <div className={s.icon}>
                      <img
                        height={item.id === 10 ? 20 : 55}
                        src={item.icon}
                        alt="logo"
                      ></img>
                    </div>
                    <span>{item.name}</span>
                  </div>
                </Link>
              ))}
              {isTeacher && user?.isActive && user?.step === "completed" && !isAdmin && teacherData.map((item: any) => (
                <Link
                  to={item?.link}
                  key={item.id}
                  onClick={() => { item.id === 9 ? dispatch(setCheckClass(true)) : item.id === 4 ? dispatch(setIsCheckingBooking(true)) : dispatch(setCheckClass(false)); setVisible(false) }}
                >
                  <div className={s.card} onClick={item?.openDrawer}>
                    <div className={s.icon}>
                      <img
                        height={item.id === 10 ? 20 : 55}
                        src={item.icon}
                        alt="logo"
                      ></img>
                    </div>
                    <span>{item.name}</span>
                  </div>
                </Link>
              ))}
              {isTeacher && (!user?.isActive || user?.step !== "completed") && TeacherNotVerifiedData.map((item: any) => (
                item.id === 10 && isAdmin ? <></> : <Link
                  to={item?.link}
                  key={item.id}
                  onClick={() => setVisible(false)}
                >
                  <div className={s.card} onClick={item?.openDrawer}>
                    <div className={s.icon}>
                      <img
                        height={55}
                        src={item.icon}
                        alt="logo"
                      ></img>
                    </div>
                    <span>{item.name}</span>
                  </div>
                </Link>
              ))}
              {isParent && MenuParent.map((item) => (
                <Link
                  to={item?.link}
                  key={item.id}
                  onClick={() => setVisible(false)}
                >
                  <div className={s.card} onClick={item?.openDrawer}>
                    <div className={s.icon}>
                      <Image
                        preview={false}
                        width={55}
                        src={item.icon}
                        alt="logo"
                      />
                    </div>
                    <span>{item.name}</span>
                  </div>
                </Link>
              ))}
              {isOrganism && MenuOrganism.map((item) => (
                <Link
                  to={item?.link}
                  key={item.id}
                  onClick={() => setVisible(false)}
                >
                  <div className={s.card} onClick={item?.openDrawer}>
                    <div className={s.icon}>
                      <Image
                        preview={false}
                        width={55}
                        src={item.icon}
                        alt="logo"
                      />
                    </div>
                    <span>{item.name}</span>
                  </div>
                </Link>
              ))}
              {isStudent && MenuStudent.map((item) => (
                item.id === 6 ? <a
                  href={item.link}
                  key={item.id}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    dispatch(setCheckClass(false));
                    setVisible(false);
                  }}
                >
                  <div className={s.card}>
                    <div className={s.icon}>
                      <Image
                        preview={false}
                        width={55}
                        src={item.icon}
                        alt="logo"
                      />
                    </div>
                    <span style={{ marginTop: "7px" }}>{item.name}</span>
                  </div>
                </a> : <Link
                  to={item?.link}
                  key={item.id}
                  onClick={() => { item.id === 8 ? dispatch(setCheckClass(true)) : dispatch(setCheckClass(false)); setVisible(false) }}
                >
                  <div className={s.card} onClick={item?.openDrawer}>
                    <div className={s.icon}>
                      <Image
                        preview={false}
                        width={item.id === 9 ? 50 : 80}
                        src={item.icon}
                        alt="logo"
                      />
                    </div>
                    <span>{item.name}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </Drawer>
      ) : (
        <Modal
          title={null}
          closable={false}
          centered
          visible={visible}
          onOk={() => setVisible(false)}
          onCancel={() => setVisible(false)}
          width={800}
          footer={null}
          className={s.menu__modal}
        >
          <div className={s.container}>
            <div className={s.row}>
              {isTeacher && user?.isActive && user?.step === "completed" && isAdmin && adminData.map((item) => (
                <Link
                  to={item?.link}
                  key={item.id}
                  onClick={() => { item.id === 9 ? dispatch(setCheckClass(true)) : dispatch(setCheckClass(false)); setVisible(false) }}
                >
                  <div className={s.card} onClick={item?.openDrawer}>
                    <div className={s.icon}>
                      <img
                        height={item.id === 10 ? 20 : 55}
                        src={item.icon}
                        alt="logo"
                      />
                    </div>
                    <span>{item.name}</span>
                  </div>
                </Link>
              ))}
              {isTeacher && user?.isActive && user?.step === "completed" && !isAdmin && teacherData.map((item) => (
                <Link
                  to={item?.link}
                  key={item.id}
                  onClick={() => { item.id === 9 ? dispatch(setCheckClass(true)) : item.id === 4 ? dispatch(setIsCheckingBooking(true)) : dispatch(setCheckClass(false)); setVisible(false) }}
                >
                  <div className={s.card} onClick={item?.openDrawer}>
                    <div className={s.icon}>
                      <img
                        height={item.id === 10 ? 20 : 55}
                        src={item.icon}
                        alt="logo"
                      />
                    </div>
                    <span>{item.name}</span>
                  </div>
                </Link>
              ))}
              {isTeacher && (!user?.isActive || user?.step !== "completed") && TeacherNotVerifiedData.map((item) => (
                item.id === 10 && isAdmin ? <></> : <Link
                  to={item?.link}
                  key={item.id}
                  onClick={() => setVisible(false)}
                >
                  <div className={s.card} onClick={item?.openDrawer}>
                    <div className={s.icon}>
                      <img
                        height={item.id === 10 ? 20 : item.id === 12 ? 30 : 55}
                        src={item.icon}
                        alt="logo"
                      />
                    </div>
                    <span>{item.name}</span>
                  </div>
                </Link>
              ))}
              {isStudent && MenuStudent.map((item) => (
                item.id === 6 ? <a
                  href={item.link}
                  key={item.id}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    dispatch(setCheckClass(false));
                    setVisible(false);
                  }}
                >
                  <div className={s.card}>
                    <div className={s.icon}>
                      <Image
                        preview={false}
                        width={55}
                        src={item.icon}
                        alt="logo"
                      />
                    </div>
                    <span style={{ marginTop: "7px" }}>{item.name}</span>
                  </div>
                </a> : <Link
                  to={item?.link}
                  key={item.id}
                  onClick={() => { item.id === 8 ? dispatch(setCheckClass(true)) : dispatch(setCheckClass(false)); setVisible(false) }}
                >
                  <div className={s.card} onClick={item?.openDrawer}>
                    <div className={s.icon}>
                      <Image
                        preview={false}
                        width={item.id === 10 ? 30 : item.id === 9 ? 30 : 55}
                        src={item.icon}
                        alt="logo"
                      />
                    </div>
                    <span style={{ marginTop: "7px" }}>{item.name}</span>
                  </div>
                </Link>
              ))}
              {isParent && MenuParent.map((item) => (
                item.id === 6 ? <a
                  href={item.link}
                  key={item.id}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    dispatch(setCheckClass(false));
                    setVisible(false);
                  }}
                >
                  <div className={s.card}>
                    <div className={s.icon}>
                      <Image
                        preview={false}
                        width={55}
                        src={item.icon}
                        alt="logo"
                      />
                    </div>
                    <span style={{ marginTop: "7px" }}>{item.name}</span>
                  </div>
                </a> : <Link
                  to={item?.link}
                  key={item.id}
                  onClick={() => { item.id === 8 ? dispatch(setCheckClass(true)) : dispatch(setCheckClass(false)); setVisible(false) }}
                >
                  <div className={s.card} onClick={item?.openDrawer}>
                    <div className={s.icon}>
                      <Image
                        preview={false}
                        width={item.id === 10 ? 30 : 55}
                        src={item.icon}
                        alt="logo"
                      />
                    </div>
                    <span style={{ marginTop: "7px" }}>{item.name}</span>
                  </div>
                </Link>
              ))}
              {isOrganism && MenuOrganism.map((item) => (
                item.id === 6 ? <a
                  href={item.link}
                  key={item.id}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    dispatch(setCheckClass(false));
                    setVisible(false);
                  }}
                >
                  <div className={s.card}>
                    <div className={s.icon}>
                      <Image
                        preview={false}
                        width={55}
                        src={item.icon}
                        alt="logo"
                      />
                    </div>
                    <span style={{ marginTop: "7px" }}>{item.name}</span>
                  </div>
                </a> : <Link
                  to={item?.link}
                  key={item.id}
                  onClick={() => { item.id === 8 ? dispatch(setCheckClass(true)) : dispatch(setCheckClass(false)); setVisible(false) }}
                >
                  <div className={s.card} onClick={item?.openDrawer}>
                    <div className={s.icon}>
                      <Image
                        preview={false}
                        width={item.id === 10 ? 30 : 55}
                        src={item.icon}
                        alt="logo"
                      />
                    </div>
                    <span style={{ marginTop: "7px" }}>{item.name}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
          <div className={s.close} onClick={() => setVisible(false)}>
            <Image preview={false} src={Close} width={20} />
          </div>
        </Modal>
      )}
    </>
  );
};

export default MenuModal;
